import { LaborBudget, LaborRules, LaborProjections } from '../pages';
import { RequireLaborAccess } from './RequireLaborAccess';

/**
 * Route elements for the Labor Management module (US2). Each owns its `RequireLaborAccess` guard,
 * so a route cannot be wired here without the gate — see `RequireLaborAccess.test.tsx`'s
 * `EveryLaborRouteElementCarriesTheGate` for the test that catches a dropped wrapper.
 */
export function LaborBudgetRouteElement() {
  return (
    <RequireLaborAccess>
      <LaborBudget />
    </RequireLaborAccess>
  );
}

export function LaborRulesRouteElement() {
  return (
    <RequireLaborAccess>
      <LaborRules />
    </RequireLaborAccess>
  );
}

export function LaborProjectionsRouteElement() {
  return (
    <RequireLaborAccess>
      <LaborProjections />
    </RequireLaborAccess>
  );
}
